export const slopeDirectionTextSetter = (slopeDirection: string) => {
    switch (slopeDirection) {
        case 'North':
            return 'شمال';
        case 'Northwest':
            return 'شمال غربی';
        case 'Northeast':
            return 'شمال شرقی';
        case 'South':
            return 'جنوب';
        case 'Southwest':
            return 'جنوب غربی';
        case 'Southeast':
            return 'جنوب شرقی';
        case 'West':
            return 'غرب';
        case 'East':
            return 'شرق';
        default:
            break;
    }
};
